/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Day/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Day({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/MonthDays/Day"
  
}) {
let settingsDataDefaultPayorScheduleAllowedDatesValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'data.default_payor_schedule.allowed_dates',
})
let dayIdValueData = fromData.useDataValue({ viewPath,
context: 'day',
path: 'id',
})
let aggregateData = fromAggregate.includes(settingsDataDefaultPayorScheduleAllowedDatesValueData, dayIdValueData)
let dayLabelValueData = fromData.useDataValue({ viewPath,
context: 'day',
path: 'label',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="settings.data.default_payor_schedule.allowed_dates"
 data="day.id"
 aggregate="/Data/aggregate.js includes"
 isSelected={aggregateData}
 onClick={onClick}
 marginLeft={dtSpaceXs}
 textWidth={20}
 data="day.label"
 text={dayLabelValueData}
/>
{children}
</React.Fragment>)
}